import { render } from "./pagePromotion.vue?vue&type=template&id=04e480cc&scoped=true"
import script from "./pagePromotion.vue?vue&type=script&lang=js"
export * from "./pagePromotion.vue?vue&type=script&lang=js"

import "./pagePromotion.vue?vue&type=style&index=0&id=04e480cc&lang=scss"
import "./pagePromotion.vue?vue&type=style&index=1&id=04e480cc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e480cc"]])

export default __exports__